<template>
  <div class="column is-half-mobile">
    <div class="box">
      <b-tooltip v-if="!bigCard" multilined :label="tooltipText">
        <!-- Single Card Content -->
        <p class="has-text-weight-bold">
          {{ text }}
        </p>
        {{
          `${payments.currencySymbol} ${formatMoney(value)} ${
            percentage ? `(${percentage}%)` : ""
          }`
        }}
      </b-tooltip>

      <!-- Aggregated Content for Big Card -->
      <div v-else class="is-flex is-flex-direction-column">
        <b-tooltip
          v-for="(card, index) in cards"
          :key="index"
          multilined
          :label="card.tooltipText"
          :style="{
            marginBottom: '0.5rem',
            paddingBottom: '0.5rem',
            fontSize: index !== 0 ? '0.75rem' : '1rem',
            borderBottom:
              index === 0
                ? '1px solid #ccc'
                : index !== 0 && index !== cards.length - 1
                ? '1px solid #ececec'
                : ''
          }"
        >
          <p class="has-text-weight-bold">{{ card.text }}</p>
          {{
            `${payments.currencySymbol} ${formatMoney(card.value)} ${
              card.percentage ? `(${card.percentage}%)` : ""
            }`
          }}
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";

export default {
  props: {
    tooltipText: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    value: {
      type: [Number, String],
      default: 0
    },
    percentage: {
      type: [Number, String],
      default: null
    },
    cards: {
      type: Array,
      default: () => []
    },
    bigCard: {
      type: Boolean,
      default: false
    }
  },

  mixins: [mask],

  computed: {
    ...mapGetters(["payments"])
  }
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.first-card {
  border-bottom: 2px solid blue;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
}
</style>
